import classNames from 'classnames';
import React from 'react';
import { HasClassName } from '../component-utils';
import './MediaControl.scss';

interface Props extends HasClassName {
}

export default function Toolbar({ className, children }: React.PropsWithChildren<Props>) {
  return <div className={classNames('MediaControl', className)}>
    {children}
  </div>
}
